import React from 'react';

const Header: React.FC = () => {
    return (
        <header className="page-header">
            <div className="logo-container">
                <img src="/logo-white.svg" alt="Korean Mate Logo" className="header-logo" />
            </div>
        </header>
    );
};

export default Header;